<template>
    <article class="product-list-item card" :data-testing="item.variation.id">
        <div class="card-body">
            <div class="product-image-wrapper tile-view-only">
                <a :href="item | itemURL(urlWithVariationId)" :title="item.texts.name1">
                    <lazy-img picture-class="product-image"
                        :image-url="item.images.variation.length > 0 ? item.images.variation[0].urlMiddle : item.images.all[0].urlMiddle"
                        :alt="item.texts.name1">
                    </lazy-img>
                </a>
            </div>
            <item-store-special :store-special="storeSpecial" :recommended-retail-price="item.prices.rrp"
                :variation-retail-price="item.prices.default" :special-offer-price="item.prices.specialOffer"
                :decimal-count="decimalCount" :bundle-type="item.variation.bundleType" :item-type="item.item.itemType">
            </item-store-special>
            <category-add-wishlist :item-id="item.variation.id"></category-add-wishlist>
            <div class="d-none d-md-block attributes__wrapper">
                <ul class="attributes__list">
                    <li class="attributes__item" v-for="categoryItemAttributes in sortedAttributes">
                        <img class="attributes__image" v-if="categoryItemAttributes.value.image != ''"
                            :src="'/images/produkte/grp/' + categoryItemAttributes.value.image"
                            :alt="categoryItemAttributes.value.names.name">
                        <span v-else class="attributes__name">
                            <span
                                v-if="categoryItemAttributes.attribute.id === 6 || categoryItemAttributes.attribute.id === 1"
                                class="attributes__icon attributes__icon--6"></span>
                            <span
                                v-else-if="categoryItemAttributes.attribute.id === 7 || categoryItemAttributes.attribute.id === 4 || categoryItemAttributes.attribute.id === 12"
                                class="attributes__icon attributes__icon--7"></span>
                            <span
                                v-else-if="categoryItemAttributes.attribute.id === 8 || categoryItemAttributes.attribute.id === 5"
                                class="attributes__icon attributes__icon--8"></span>
                            <span
                                v-else-if="categoryItemAttributes.attribute.id === 13 || categoryItemAttributes.attribute.id === 2"
                                class="attributes__icon attributes__icon--13"></span>
                            <span
                                v-else-if="categoryItemAttributes.attribute.id === 14 || categoryItemAttributes.attribute.id === 11"
                                class="attributes__icon attributes__icon--14"></span>
                            <span v-else-if="categoryItemAttributes.attribute.id === 15"
                                class="attributes__icon attributes__icon--15"></span>
                            <span v-else-if="categoryItemAttributes.attribute.id === 16"
                                class="attributes__icon attributes__icon--16"></span>
                            <span v-else class="attributes__icon attributes__icon--else"></span>

                            <span class="attributes__name-text">
                                {{ categoryItemAttributes.value.names.name }}
                            </span>
                        </span>
                    </li>
                </ul>
                <div class="attributes__more" v-if="sortedAttributes.length > 0">
                    {{ $translate('OD3dprimaV2::Template.moreOptions') }}
                </div>
            </div>
            <div class="item-details__wrapper">
                <div class="product-info">
                    <div class="item-details__informations">
                        <!-- DUPLICATE IMAGE FOR LIST VIEW -->
                        <div class="product-image-wrapper list-view-only">
                            <a :href="item | itemURL(urlWithVariationId)" :title="item.texts.name1">
                                <lazy-img picture-class="product-image"
                                    :image-url="item.images.variation.length > 0 ? item.images.variation[0].urlMiddle : item.images.all[0].urlMiddle"
                                    :alt="item.texts.name1">
                                </lazy-img>
                            </a>
                        </div>
                        <!-- DUPLICATE IMAGE FOR LIST VIEW -->
                        <div class="item-details__info">

                            <slot name="ratings"></slot>

                            <a :href="item | itemURL(urlWithVariationId)" class="product-name">
                                {{ item | itemName }}
                            </a>
                            <span class="item-details__item-id small tile-view-only">
                                {{ $translate('OD3dprimaV2::Template.variationId') }}: <span>{{ item.variation.id
                                }}</span>
                            </span>
                            <span class="item-details__item-id small tile-view-only">
                                {{ $translate("OD3dprimaV2::Template.ItemNo") }}: <span>{{ item.item.id }}</span>
                            </span>
                            <div class="item-details__attributes list-view-only">
                                <span class="product-id">
                                    <strong>
                                        {{ $translate('OD3dprimaV2::Template.variationId') }}: <span>{{
                                            item.variation.id }}</span>
                                    </strong>
                                </span>
                                <span class="product-id">
                                    <strong>
                                        {{ $translate("OD3dprimaV2::Template.ItemNo") }}: <span>{{ item.item.id
                                        }}</span>
                                    </strong>
                                </span>
                                <span v-if="ean" class="product-ean list-view-only">
                                    <strong>
                                        {{ $translate("OD3dprimaV2::Template.EAN") }}: <span>{{ ean.code }}</span>
                                    </strong>
                                </span>
                                <!--                                <div class="item-details__attributes" v-if="item.attributes.length > 0">-->
                                <!--                                    <ul class="list-unstyled">-->
                                <!--                                        <li class="d-flex" v-for="attribute in item.attributes">-->
                                <!--                                            <div class="d-none d-md-block">-->
                                <!--                                                {{ attribute.attribute.names.name }}:-->
                                <!--                                            </div>-->
                                <!--                                            {{ attribute.value.names.name }}-->
                                <!--                                        </li>-->
                                <!--                                    </ul>-->
                                <!--                                    <div v-if="item.filter.hasChildren">-->
                                <!--                                        {{ $translate("OD3dprimaV2::Template.moreVariations") }}-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="attributes attributes-list-view-only" v-if="sortedAttributes.length">
                            <ul class="attributes__list">
                                <li :class="'attributes__item attributes__item--' + categoryItemAttributes.attribute.id"
                                    v-for="categoryItemAttributes in sortedAttributes">
                                    <img class="attributes__image" v-if="categoryItemAttributes.value.image != ''"
                                        :src="'/images/produkte/grp/' + categoryItemAttributes.value.image"
                                        :alt="categoryItemAttributes.value.names.name">
                                    <span class="attributes__name">
                                        <span
                                            v-if="categoryItemAttributes.attribute.id === 6 || categoryItemAttributes.attribute.id === 1"
                                            class="attributes__icon attributes__icon--6"></span>
                                        <span
                                            v-else-if="categoryItemAttributes.attribute.id === 7 || categoryItemAttributes.attribute.id === 4 || categoryItemAttributes.attribute.id === 12"
                                            class="attributes__icon attributes__icon--7"></span>
                                        <span
                                            v-else-if="categoryItemAttributes.attribute.id === 8 || categoryItemAttributes.attribute.id === 5"
                                            class="attributes__icon attributes__icon--8"></span>
                                        <span
                                            v-else-if="categoryItemAttributes.attribute.id === 13 || categoryItemAttributes.attribute.id === 2"
                                            class="attributes__icon attributes__icon--13"></span>
                                        <span
                                            v-else-if="categoryItemAttributes.attribute.id === 14 || categoryItemAttributes.attribute.id === 11"
                                            class="attributes__icon attributes__icon--14"></span>
                                        <span v-else-if="categoryItemAttributes.attribute.id === 15"
                                            class="attributes__icon attributes__icon--15"></span>
                                        <span v-else-if="categoryItemAttributes.attribute.id === 16"
                                            class="attributes__icon attributes__icon--16"></span>
                                        <span v-else class="attributes__icon attributes__icon--else"></span>
                                        <span class="attributes__name-text">
                                            {{ categoryItemAttributes.value.names.name }}
                                        </span>
                                    </span>
                                </li>
                            </ul>
                            <div class="attributes__more">
                                {{ $translate('OD3dprimaV2::Template.moreOptions') }}
                            </div>
                        </div>
                    </div>

                    <slot name="before-prices"></slot>

                    <div class="item-details__price-wrapper">
                        <div>
                            <div class="product-price" v-if="item.prices.default.unitPrice.value > 0"
                                :class="{ 'product-price--sale': item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value }"
                                :style="!mounted ? 'opacity: 0; padding-top: 2px' : 'opacity: 1'">
                                <template
                                    v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value">
                                    <span class="product-price--uvp" v-if="item.prices.specialOffer">
                                        {{ getPrice('prices.default.data.unitPrice' + appendNet) | currency }}
                                    </span>
                                    <span class="product-price--uvp" v-else>
                                        {{ getPrice('prices.rrp.data.unitPrice' + appendNet) | currency }}
                                    </span>
                                </template>
                                <span v-if="item.item.itemType === 'set'">
                                    {{ $translate("Ceres::Template.itemSetPrice", { price: getPrice('itemSetPrice') })
                                    }}
                                </span>
                                <template
                                    v-else-if="!!item.item && item.item.salableVariationCount > 1 && $ceres.isCheapestSorting">
                                    <span v-if="mounted"
                                        :inner-html.prop="$translate('OD3dprimaV2::Template.categoryItemFromPrice', { price: getPrice('itemPrice', true) })"></span>
                                    <span v-else>
                                        {{ $translate('OD3dprimaV2::Template.categoryItemFromPrice', {
                                            price:
                                                getPrice('itemPrice')
                                        }) }}
                                    </span>
                                </template>
                                <template v-else>
                                    <span v-if="mounted"
                                        :inner-html.prop="getPrice('prices.default.data.unitPrice' + appendNet) | specialOffer(item.prices, 'data', 'unitPrice' + appendNet) | currency(true)"></span>
                                    <span v-else>
                                        {{ getPrice('prices.default.data.unitPrice' + appendNet) |
                                            specialOffer(item.prices, 'data', 'unitPrice' + appendNet) | currency }}
                                    </span>
                                </template>
                                <span v-if="item.variation.mayShowUnitPrice === true" class="product-price--base small">
                                    ({{ $translate("OD3dprimaV2::Template.basePrice") }}:
                                    {{ getPrice('prices.default.data.basePrice' + appendNet) / item.unit.content |
                                        currency }}/{{ unitName }})
                                </span>
                            </div>
                            <div v-if="item.stock.net >= 1" class="item-details__stock"
                                :class="{ 'item-details__stock--no': item.stock.net < 1 }">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-stock-icon"></use>
                                </svg>
                                <span class="stock-list-view">
                                    {{ $translate("OD3dprimaV2::Template.stock") }}
                                </span>
                                <span class="stock-tile-view">
                                    {{ $translate("OD3dprimaV2::Template.stockAvailable") }}
                                </span>
                                &nbsp;{{ stock }}
                            </div>
                            <div v-if="item.stock.net < 1" class="category-listing-estimated small">
                                <span class="product-detail__availability" v-if="showEstimatedDate">
                                    <span :title="$translate('Ceres::Template.singleItemShippingCosts')">
                                        <svg class="product-detail-availability__truck" id="Ebene_1" data-name="Ebene 1"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
                                            <path class="cls-1"
                                                d="M386.51 192.94l.11-.32a4.41 4.41 0 0 0 .2-1.3 4.23 4.23 0 0 0-1.26-3l-.25-.24-.11-.32a27.07 27.07 0 0 0-13.43-15l-.4-.18-19.72-7.4-11.8-44.82a27.06 27.06 0 0 0-26.09-19.42H271.9v-13a10 10 0 0 0-10-10H32.07a10 10 0 0 0-10 10v160.84a10 10 0 0 0 10 10H53l-.58 1.93a39.31 39.31 0 0 0-1.22 5.53l-.2 1.28H26.33a4.25 4.25 0 1 0 0 8.49H51l.18 1.29a38.72 38.72 0 0 0 76.64 0l.18-1.3h14.71v1.5a15.75 15.75 0 0 0 15.73 15.74H193a15.76 15.76 0 0 0 15.74-15.74V276h72.17l.18 1.29a38.72 38.72 0 0 0 76.64 0l.19-1.29h24.7a4.25 4.25 0 0 0 0-8.49h-24.7l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h20.93a10 10 0 0 0 10-10v-51.69a26.72 26.72 0 0 0-.26-3.79zM271.9 109.38h41.86a18.63 18.63 0 0 1 17.92 13.26l10.91 41.45H271.9zm0 63.2h75.43l20.91 7.86a18.81 18.81 0 0 1 5.33 4.13l2.24 2.51H271.9zM89.53 302a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 89.53 302zm54.12-41.23a15.66 15.66 0 0 0-.9 5.25v1.5H128l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h18.3zm56.56 16.74a7.26 7.26 0 0 1-7.25 7.25h-34.48a7.25 7.25 0 0 1-7.24-7.25V266a7.25 7.25 0 0 1 7.24-7.25H193a7.26 7.26 0 0 1 7.25 7.25zM124 250.28a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13H30.57v-31.73H210.2a4.25 4.25 0 1 0 0-8.49H30.57V86.39h232.84v163.89zm158.27 10.42a39 39 0 0 0-1.22 5.53l-.18 1.29H208.7V266a15.92 15.92 0 0 0-.9-5.25l-.71-2h75.75zm37.1 41.3a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 319.37 302zm59-91.94h-7.24a10 10 0 0 0-10 10v5.75a10 10 0 0 0 10 10h7.24v14.49h-24.52a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13h-13v-54.73h106.39zm0 8.49v8.75h-8.75v-8.75z" />
                                            <path class="cls-1"
                                                d="M320.8 258.43a14.67 14.67 0 1 0 14.67 14.67 14.69 14.69 0 0 0-14.67-14.67zm0 22.85a8.18 8.18 0 1 1 8.2-8.18 8.19 8.19 0 0 1-8.2 8.18zM89.83 257.29A14.67 14.67 0 1 0 104.49 272a14.69 14.69 0 0 0-14.66-14.71zm0 22.85A8.18 8.18 0 1 1 98 272a8.19 8.19 0 0 1-8.17 8.14z" />
                                        </svg>
                                        {{ estimatedAvailable }}
                                    </span>
                                </span>
                                <div class="category-listing-request" v-else-if="orderOnRequest">
                                    {{ $translate("OD3dprimaV2::Template.orderOnRequest") }}
                                </div>
                                <span class="product-detail__availability" v-else>
                                    <span :title="$translate('Ceres::Template.singleItemShippingCosts')">
                                        <svg class="product-detail-availability__truck" id="Ebene_1" data-name="Ebene 1"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
                                            <path class="cls-1"
                                                d="M386.51 192.94l.11-.32a4.41 4.41 0 0 0 .2-1.3 4.23 4.23 0 0 0-1.26-3l-.25-.24-.11-.32a27.07 27.07 0 0 0-13.43-15l-.4-.18-19.72-7.4-11.8-44.82a27.06 27.06 0 0 0-26.09-19.42H271.9v-13a10 10 0 0 0-10-10H32.07a10 10 0 0 0-10 10v160.84a10 10 0 0 0 10 10H53l-.58 1.93a39.31 39.31 0 0 0-1.22 5.53l-.2 1.28H26.33a4.25 4.25 0 1 0 0 8.49H51l.18 1.29a38.72 38.72 0 0 0 76.64 0l.18-1.3h14.71v1.5a15.75 15.75 0 0 0 15.73 15.74H193a15.76 15.76 0 0 0 15.74-15.74V276h72.17l.18 1.29a38.72 38.72 0 0 0 76.64 0l.19-1.29h24.7a4.25 4.25 0 0 0 0-8.49h-24.7l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h20.93a10 10 0 0 0 10-10v-51.69a26.72 26.72 0 0 0-.26-3.79zM271.9 109.38h41.86a18.63 18.63 0 0 1 17.92 13.26l10.91 41.45H271.9zm0 63.2h75.43l20.91 7.86a18.81 18.81 0 0 1 5.33 4.13l2.24 2.51H271.9zM89.53 302a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 89.53 302zm54.12-41.23a15.66 15.66 0 0 0-.9 5.25v1.5H128l-.19-1.29a39 39 0 0 0-1.22-5.53l-.57-1.93h18.3zm56.56 16.74a7.26 7.26 0 0 1-7.25 7.25h-34.48a7.25 7.25 0 0 1-7.24-7.25V266a7.25 7.25 0 0 1 7.24-7.25H193a7.26 7.26 0 0 1 7.25 7.25zM124 250.28a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13H30.57v-31.73H210.2a4.25 4.25 0 1 0 0-8.49H30.57V86.39h232.84v163.89zm158.27 10.42a39 39 0 0 0-1.22 5.53l-.18 1.29H208.7V266a15.92 15.92 0 0 0-.9-5.25l-.71-2h75.75zm37.1 41.3a30.23 30.23 0 1 1 30.23-30.23A30.27 30.27 0 0 1 319.37 302zm59-91.94h-7.24a10 10 0 0 0-10 10v5.75a10 10 0 0 0 10 10h7.24v14.49h-24.52a4.08 4.08 0 0 0-1 .13l-1 .25-.59-.85a38.67 38.67 0 0 0-63.74 0l-.58.85-1-.25a4 4 0 0 0-1-.13h-13v-54.73h106.39zm0 8.49v8.75h-8.75v-8.75z" />
                                            <path class="cls-1"
                                                d="M320.8 258.43a14.67 14.67 0 1 0 14.67 14.67 14.69 14.69 0 0 0-14.67-14.67zm0 22.85a8.18 8.18 0 1 1 8.2-8.18 8.19 8.19 0 0 1-8.2 8.18zM89.83 257.29A14.67 14.67 0 1 0 104.49 272a14.69 14.69 0 0 0-14.66-14.71zm0 22.85A8.18 8.18 0 1 1 98 272a8.19 8.19 0 0 1-8.17 8.14z" />
                                        </svg>
                                        {{ estimatedAvailable }}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="list-view-only-mobile">
                            <add-to-basket v-if="item.prices.default.unitPrice.value > 0"
                                data-testing="item-add-to-basket" :variation-id="item.variation.id"
                                :is-salable="!!item.filter && item.filter.isSalable"
                                :has-children="!!item.item && item.item.salableVariationCount > 1"
                                :interval-quantity="item.variation.intervalOrderQuantity || 1"
                                :minimum-quantity="item.variation.minimumOrderQuantity"
                                :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                                :order-properties="item.properties.filter(function (prop) { return prop.property.isOderProperty })"
                                :has-order-properties="item.hasOrderProperties"
                                :has-required-order-property="item.hasRequiredOrderProperty" :use-large-scale="false"
                                :show-quantity="true" :item-url="item | itemURL(urlWithVariationId)"
                                :has-price="item | hasItemDefaultPrice" :item-type="item.item.itemType"
                                :has-graduated-price="itemGraduatedPriceisCheapestSorting || itemGraduatedPricesalableVariationCount"
                                :item-free-four="item.item.free4">
                            </add-to-basket>
                            <a v-else class="btn btn-block btn-primary btn-appearance add-to-basket__btn"
                                :href="item | itemURL(urlWithVariationId)">
                                {{ $translate('OD3dprimaV2::Template.contactForAQuote') }}
                            </a>
                        </div>
                    </div>

                    <slot name="after-prices"></slot>

                </div>
            </div>
        </div>
    </article>
</template>

<script>
import { mapState } from "vuex";
import ItemStoreSpecial from "~/app/components/itemList/ItemStoreSpecial.vue";
import { isNullOrUndefined } from "ceres/app/helper/utils";
import { getSlotData } from "ceres/app/helper/getSlotData";

import dayjs from "dayjs";
require('dayjs/locale/de');
require('dayjs/locale/sv');
const _orderBy = require("lodash/orderBy");

export default {

    components: {
        ItemStoreSpecial
    },

    props: {
        decimalCount:
        {
            type: Number,
            default: 0
        },
        imageUrlAccessor:
        {
            type: String,
            default: "urlMiddle"
        },
        itemData:
        {
            type: Object
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        forceUrlWithVariationId:
        {
            type: Boolean,
            default: false
        }
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    data() {
        return {
            mounted: false
        }
    },

    computed: {

        ...mapState({
            currentPriceType: state => state.localization.currentPriceType
        }),

        item() {
            return this.itemData || this.itemSlotData || this.itemDataRef;
        },

        itemSlotData: getSlotData('item-data'),

        sortedAttributes() {
            if (this.item.attributes) {

                return _orderBy(this.item.attributes, 'attributeId');
            } else {
                return [];
            }
        },
        storeSpecial() {
            return this.item.item.storeSpecial;
        },

        texts() {
            return this.item.texts;
        },

        urlWithVariationId() {
            return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        ean() {

            if (!isNullOrUndefined(this.item.barcodes) && this.item.barcodes.length > 0) {
                return this.item.barcodes.find(code => code.name === 'EAN_13');
            }

            return undefined;
        },

        stock() {
            if (this.item.stock.net < 0) {
                return '0';
            } else if (this.item.stock.net > 50) {
                return '50+';
            } else {
                return '' + this.item.stock.net;
            }
        },

        appendNet() {

            if (this.currentPriceType === 'b2b') {
                return 'Net';
            }

            return '';
        },

        unitName() {
            if (this.item.unit.unitOfMeasurement === 'KGM') {
                return 'kilogram';
            }
            if (!isNullOrUndefined(this.item.unit.names.name)) {
                return this.item.unit.names.name;
            }
            return '';
        },

        estimatedAvailable() {
            dayjs.locale(App.language);
            const estimatedAvailableDate = dayjs(this.item.variation.estimatedAvailableAt);
            const today = dayjs();

            if (today < estimatedAvailableDate) {
                return this.$translate('OD3dprimaV2::Template.itemDeliveryConfirmed') + ' ' +
                    estimatedAvailableDate.format('MMM DD');
            }
            else {
                return this.$translate('OD3dprimaV2::Template.itemDeliveryNotConfirmed');
            }
        },

        showEstimatedDate() {
            dayjs.locale(App.language);
            const estimatedAvailableDate = dayjs(this.item.variation.estimatedAvailableAt);
            const today = dayjs();
            return today < estimatedAvailableDate;
        },

        orderOnRequest() {
            if (typeof this.item.variationProperties !== 'undefined' && this.item.variationProperties.length >= 0) {
                for (let key in this.item.variationProperties) {

                    const property = this.item.variationProperties[key].properties.find(property => property.id === 23);

                    if (!isNullOrUndefined(property) && property.values.value === "1") {
                        return true
                    }
                }
            }

            return false
        },

        basePrice() {
            return this.item.prices.default.basePrice;
        },

        itemPriceGraduated() {
            let unitPrice;
            if (App.config.item.enableGraduatedPrices) {
                unitPrice = this.item.prices.graduatedPrices.length > 0
                    ? this.item.prices.graduatedPrices[0].unitPrice
                    : this.item.prices.default.unitPrice;
            } else {
                unitPrice = this.item.prices.default.unitPrice;
            }

            return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
        },

        itemGraduatedPriceisCheapestSorting() {
            return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
        },

        itemGraduatedPricesalableVariationCount() {
            return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
        },

        hasCrossPrice() {
            const hasRrpPrice = !!this.item.prices.rrp &&
                this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

            const hasBeforePrice = !!this.item.prices.specialOffer &&
                !!this.item.prices.default &&
                this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

            return hasRrpPrice || hasBeforePrice;
        },
    },

    mounted() {
        this.mounted = true;
    },

    methods: {
        getPrice(pricePath, smallSign = false) {

            //dotted path
            if (pricePath.indexOf('.') > -1) {
                return pricePath.split('.').reduce((o, i) => o[i], this.item);
            }

            //functions
            if (pricePath === 'itemPrice') {
                return this.$options.filters.currency(
                    this.$options.filters.specialOffer(
                        this.getPrice('prices.default.data.unitPrice' + this.appendNet),
                        this.item.prices,
                        'data',
                        'unitPrice' + this.appendNet
                    ),
                    smallSign
                );
            }
            if (pricePath === 'itemSetPrice') {
                return this.$options.filters.currency(
                    this.getPrice('prices.default.data.price' + this.appendNet),
                    smallSign
                );
            }
        }
    }
}
</script>
this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

const hasBeforePrice = !!this.item.prices.specialOffer &&
!!this.item.prices.default &&
this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

return hasRrpPrice || hasBeforePrice;
},
},

mounted() {
this.mounted = true;
},

methods: {
getPrice(pricePath, smallSign = false) {

//dotted path
if(pricePath.indexOf('.') > -1) {
return pricePath.split('.').reduce((o,i) => o[i], this.item);
}

//functions
if(pricePath === 'itemPrice') {
return this.$options.filters.currency(
this.$options.filters.specialOffer(
this.getPrice('prices.default.data.unitPrice'+this.appendNet),
this.item.prices,
'data',
'unitPrice'+this.appendNet
),
smallSign
);
}
if(pricePath === 'itemSetPrice') {
return this.$options.filters.currency(
this.getPrice('prices.default.data.price'+this.appendNet),
smallSign
);
}
}
}
}
</script>
